import {
  BoosterType,
  IBgFlashId,
  IBoosterConfigId,
  IShootingStarId,
  ITimedTargetId,
} from 'core/api/prescription/booster/identifiers'

// ============================
// =          Demos           =
// ============================

const SHOOTING_STARS_DEMO_RED_ID: IShootingStarId = {
  type: 'SHOOTING_STARS',
  version: '20170801-DEMO_RED',
}

const SHOOTING_STARS_DEMO_BLUE_ID: IShootingStarId = {
  type: 'SHOOTING_STARS',
  version: '20170801-DEMO_BLUE',
}

const BG_FLASHES_DEMO_RRR_ID: IBgFlashId = {
  type: 'BG_FLASHES',
  version: '20170801-DEMO_RRR',
}

const BG_FLASHES_DEMO_GGG_ID: IBgFlashId = {
  type: 'BG_FLASHES',
  version: '20170801-DEMO_GGG',
}

const TIMED_TARGET_DEMO_ID: ITimedTargetId = {
  type: 'TIMED_TARGET',
  version: '20170801-DEMO',
}

// ============================
// =          20170907        =
// ============================

const SHOOTING_STARS__20170908_ID: IShootingStarId = {
  type: 'SHOOTING_STARS',
  version: '20170907-5-white',
}

const BG_FLASHES__20170908_ID: IBgFlashId = {
  type: 'BG_FLASHES',
  version: '20170907-5-white',
}

const TIMED_TARGET__20170908_ID: ITimedTargetId = {
  type: 'TIMED_TARGET',
  version: '20170907',
}

// ============================
// =          20171003        =
// ============================

const BG_FLASHES__20171003_ID: IBgFlashId = {
  type: 'BG_FLASHES',
  version: '20171003-5-white',
}

// =============================
// =          Exports          =
// =============================

/** All booster configuration unique ids. */
export const BoosterIds: {[key: string]: IBoosterConfigId<BoosterType>} = {
  // Demos
  SHOOTING_STARS_DEMO_RED_ID,
  SHOOTING_STARS_DEMO_BLUE_ID,
  BG_FLASHES_DEMO_RRR_ID,
  BG_FLASHES_DEMO_GGG_ID,
  TIMED_TARGET_DEMO_ID,
  // 20170907
  SHOOTING_STARS__20170908_ID,
  BG_FLASHES__20170908_ID,
  TIMED_TARGET__20170908_ID,
  // 20171003
  BG_FLASHES__20171003_ID,
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/booster/identifiers.ts